import { Input, Form, Typography } from "antd";
import { BTN_TXT } from "../../constants/constants";
import PrimaryButton from "../CustomButton/PrimaryButton";
import CustomButton from "../CustomButton/Button";
import { CheckCircleFilled } from "@ant-design/icons";
import "./Input.scss";


const { Text } = Typography;

const isEmailField = (type, name) => {
    if (type === "email") return true;
    const fieldName = String(name || "").toLowerCase();
    return (
        fieldName === "email" ||
        fieldName.endsWith("email") ||
        fieldName.includes("email")
    );
};

const toLowerEmail = (value) =>
    typeof value === "string" ? value.toLowerCase() : value;

const InputWithButton = ({
    label,
    isRequired,
    isTextArea,
    verifyBtn,
    disableVerify,
    isVerified,
    handleVerify,
    verifyLoading,
    isUpperCase = false,
    ...inputProps
}) => {
    const shouldLowercaseEmail = isEmailField(inputProps.type, inputProps.name);

    return (
        <Form.Item
            label={
                <Text>
                    {label}
                    {isRequired && <Text type="danger"> *</Text>}
                </Text>
            }
            name={inputProps.name}
            rules={inputProps.rules}
            normalize={shouldLowercaseEmail ? toLowerEmail : undefined}
            className="custom-input-form-item"
        >
            <Input
                className="custom-input-with-button"
                {...inputProps}
                onInput={(e) => {
                    let value = e.target.value;

                    if (shouldLowercaseEmail) {
                        value = value.toLowerCase();
                    }

                    if (isUpperCase) {
                        value = value.toUpperCase();
                    }

                    e.target.value = value;

                    // existing onInput unte call avvali
                    inputProps.onInput?.(e);
                }}
                onWheel={(e) => {
                    if (inputProps.type === "number") {
                        e.currentTarget.blur();
                    }
                    inputProps.onWheel?.(e);
                }}
                addonAfter={
                    verifyBtn ? (
                        isVerified ? (
                            <CustomButton
                                type="text"
                                style={{ backgroundColor: "#00874F" }}
                                icon={<CheckCircleFilled style={{ color: "#ffffff" }} />}
                            />
                        ) : (
                            <PrimaryButton
                                disabled={disableVerify}
                                loading={verifyLoading}
                                onClick={handleVerify}
                            >
                                {BTN_TXT.VERIFY}
                            </PrimaryButton>
                        )
                    ) : null
                }
            />
        </Form.Item >


    );
};

export default InputWithButton;
